var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("el-alert", {
        attrs: {
          type: "info",
          closable: false,
          title: "此组件为固定字段结构，无法自定义列",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }